import './controls_settings.scss'
import {h, createRef, Component } from 'preact' 
import { BaseAnnotation } from '../base_annotation';
import { IoMdMore } from 'react-icons/io'
import { PLAYER_CONTROL_EVENT } from 'constants/events'
import { RadioButtons } from '../../components/control_radio_buttons'
import { accessible } from 'utilities/accessibility'


const MENU_ITEM_HEIGHT = 94;
const CONTROL_BAR_HEIGHT = 12;
const TOTAL_ITEMS = 2

export class ControlsSettings extends BaseAnnotation {
    constructor(props) {
        super(props)
        this.menuRef = createRef()
        this.menuButtonRef = createRef();
        this.state = {
            showMenu: false,
            captionsEnabled: true,
            descriptionsEnabled: false
        }
    }

    componentDidMount() {
        document.addEventListener('click', this.onClickOutsideSettingsMenu);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.onClickOutsideSettingsMenu);
    }

    onClickOutsideSettingsMenu = e => {
        if (!this.state.showMenu) return;
        const buttonTargetIds = ['icon-on', 'icon-off']

        const menuClicked = this.menuRef?.current?.contains?.(e.target);

        if (!menuClicked && !buttonTargetIds.includes(e.target.id)) {
            this.setState({
                showMenu: false
            })
        }
    }

    onToggleMenu = () => {
        const { showMenu } = this.state; 

        this.setState({showMenu: !showMenu })
    }

    toggleCaptionsOn = (e) => {
        this.setState({
            captionsEnabled: true
        })

        this.eventBus.emit(PLAYER_CONTROL_EVENT.CAPTIONS_ENABLED)
    }

    toggleCaptionsOff = (e) => { 
        this.setState({
            captionsEnabled: false
        })

        this.eventBus.emit(PLAYER_CONTROL_EVENT.CAPTIONS_DISABLED)
    }

    toggleDescriptionsOn = () => {
        this.setState({
            descriptionsEnabled: true
        })

        this.eventBus.emit(PLAYER_CONTROL_EVENT.AUDIO_DESCRIPTIONS_ENABLED)
    }

    toggleDescriptionsOff = () => {
        this.setState({
            descriptionsEnabled: false
        })

        this.eventBus.emit(PLAYER_CONTROL_EVENT.AUDIO_DESCRIPTIONS_DISABLED)
    }
    
    getClasses(icon) {
        return `settings-icon captions-icon ${this.state[icon] ? 'active' : ''}`
    }

    get topOffset() {
        const itemsHeight = this.totalItemsHeight > this.definedMaxHeight ? this.definedMaxHeight : this.totalItemsHeight;
        return (-1 * (CONTROL_BAR_HEIGHT + itemsHeight)) + 'px';
    }

    get totalItemsHeight () {
        return TOTAL_ITEMS * MENU_ITEM_HEIGHT;
    }

    get definedMaxHeight() {
        const { dimensions = null } = this.props; 

        if (!dimensions.container) return 0; 

        const topMargin = 64; 
        return dimensions.container.height - topMargin; 
    }

    get containerAttrs() {
        return {
            ref: this.menuRef,
            className: 'controls-settings-menu',
            title: 'General Control Settings',
            ariaExpanded: this.state.showMenu,
            'aria-label': 'Controls for Audio Descriptions and Captions',
            onClick: this.onToggleMenu,
            ...accessible(this.onToggleMenu)
            
        };
    }

    get expandControlAttrs() {
        ariaExpanded: this.state.showMenu
    }

    get showMenuButtonAttrs() {
        return {
            className: 'show-settings-menu-button',
            style: { fontSize: '2em' },
            tabIndex: '-1',
            'aria-hidden': true 
        };
    }

    render() {
        const { showMenu, captionsEnabled, descriptionsEnabled } = this.state;
        const wrapperStyle = {
            top: this.topOffset
        }

        return (
            <div>
                <div {...this.containerAttrs}>
                    <IoMdMore {...this.showMenuButtonAttrs}/>
                </div>
                {showMenu && (
                    <div className="control-dropdown-menu" style={wrapperStyle}>
                        <div className="control-dropdown-list">
                            <fieldset className="controls-options-setting" id="captions">
                                <legend className="menu-options-header">Captions</legend>
                                <RadioButtons 
                                    toggleOn={this.toggleCaptionsOn}
                                    toggleOff={this.toggleCaptionsOff} 
                                    optionOn={captionsEnabled}
                                    menuButtonRef={this.menuButtonRef}
                                    ariaLabelType="Captions"
                                />
                            </fieldset>
                            <fieldset className="controls-options-setting" id="descriptions">
                                <legend className="menu-options-header">Audio Descriptions</legend>
                                <RadioButtons 
                                    optionOn={descriptionsEnabled}
                                    onClick={this.toggleAudioDescriptions}
                                    menuButtonRef={this.menuButtonRef}
                                    toggleOn={this.toggleDescriptionsOn}
                                    toggleOff={this.toggleDescriptionsOff}
                                    ariaLabelType="Audio Descriptions"
                                />
                            </fieldset>
                        </div>
                    </div>
                )}
            </div>
        )
    }
}
